import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import format from 'react-format-props';
import propTypes from 'prop-types';
import classNames from 'classnames';
import * as actions from '../../store/itemReducer/actions';
import BtnToggleRead from '../ButtonToggleRead';
import If from '../If';
import EventsReporter from '../../../shared/events/reporter';
import { EventTypes } from '../../../shared/events/types';
import { LAYOUT_SOURCES } from '../../../shared/types/layoutSources';
import * as selectors from './selectors';
import './style.scss';

export function ItemUnreadCount({ id, subType, layoutSource, isRead = false, unreadCount = null, toggleRead }) {
    const unreadClass = classNames('unread-container', { read: isRead });

    const onToggle = () => {
        reportToggled();
        toggleRead();
    };

    const reportToggled = () => {
        const eventKey = isRead ? EventTypes.notification.markedAsUnread : EventTypes.notification.markedAsRead;

        const item = { id, subType };

        EventsReporter.report(eventKey, {
            item,
            layoutSource,
        });
    };

    return (
        <span className={unreadClass}>
            <If condition={unreadCount > 1}>
                <span className="unread-count">{unreadCount}</span>
            </If>
            <BtnToggleRead isRead={isRead} toggleRead={onToggle} />
        </span>
    );
}

ItemUnreadCount.propTypes = {
    id: propTypes.string,
    subType: propTypes.string,
    layoutSource: propTypes.oneOf(Object.values(LAYOUT_SOURCES)),
    unreadCount: propTypes.string,
    toggleRead: propTypes.func,
    isRead: propTypes.bool,
};

const mapStateToProps = (state, { item }) => ({
    source: selectors.source(item),
    id: item.id,
});

const mergeProps = (stateProps, { itemMarkRead, itemMarkUnread }, { item, layoutSource }) => ({
    ...stateProps,
    ...item,
    layoutSource,
    toggleRead: () => (item.isRead ? itemMarkUnread(stateProps) : itemMarkRead(stateProps)),
});

export default compose(
    connect(mapStateToProps, actions, mergeProps),
    format(({ id, subType, layoutSource, unreadCount, toggleRead, isRead }) => ({
        id,
        subType,
        layoutSource,
        toggleRead,
        isRead,
        unreadCount: selectors.formatUnreadCount(unreadCount),
    }))
)(ItemUnreadCount);
